module.exports = __webpack_public_path__ + "img/D.566464ae.png";